import type { Location as LocationModel } from '@/adapters/catalogv1.g';

export function extractLocation(model: LocationModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.location_ref ?? '',
    name: model.name ?? '',
    address: model.address,
    city: model.city,
    state: model.state,
    country: model.country,
    postalCode: model.postal_code,
    latitude: model.latitude,
    longitude: model.longitude,
    type: model.type,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogLocation = ReturnType<typeof extractLocation>;
